const Constants = {
  AdminRole: 'Contractor.Escalation.Write',
  ContractorManagerRole: 'Contractor.Manager'
}

export default Constants